import graphqlClient from "./graphqlClient";
import {
  GET_CEREBRO_EVENT_TYPES,
  GET_CEREBRO_EVENTS
} from "./graphql/cerebro-queries";

export default class CerebroApi {
  getCerebroEventTypes() {
    return graphqlClient
      .query({
        query: GET_CEREBRO_EVENT_TYPES
      })
      .then(r => r.data)
      .then(r => r.cerebroEventTypes);
  }

  getCerebroEvents(startDate, endDate, eventTypes) {
    return graphqlClient
      .query({
        query: GET_CEREBRO_EVENTS,
        variables: {
          startDate: startDate,
          endDate: endDate,
          eventTypes: eventTypes
        }
      })
      .then(r => r.data)
      .then(r => {
        return r.cerebroEvents;
      });
  }
}



// WEBPACK FOOTER //
// ./src/httpClients/CerebroApi.js